import {Vector3} from 'three';
import {DataObject} from './data-object.model';

export class Annotation extends DataObject {
    public static readonly urlName = 'annotations';

    public patient = '';
    // public bodypart = '';
    public coordinates: Vector3;
    public notes = '';
    public icon = 'circle';

    public fromObject(obj: any): Annotation {
        this._id = obj.id;
        this.patient = obj.patient;
        // this.bodypart = obj.bodypart;
        this.coordinates = obj.coordinates;
        this.notes = obj.notes;
        this.icon = obj.icon;
        return this;
    }

    public toJSON(): any {
        return {
            patient: this.patient,
            // bodypart: this.bodypart,
            coordinates: {
                x: this.coordinates.x,
                y: this.coordinates.y,
                z: this.coordinates.z
            },
            notes: this.notes,
            icon: this.icon,
        };
    }

}

